<div style="display: flex; flex-direction: row; padding: 1rem;">
  <mat-icon fontSet="material-symbols-outlined"
            style="margin-right: 10px; padding-top: 1rem; font-size: 2rem; width: 2rem; height: 3rem; color: var(--mat-sys-outline)">{{icon}}</mat-icon>
  <div style="display: flex; flex-direction: column; width: 90%">
    <div style="display: flex; flex-direction: row; align-items: center; gap: 6px; justify-content: space-between">
      <div>
        <p class="title">{{subject}}</p>
        <p class="subtitle disabled-color">{{taskStartUser}} {{'STARTED' | translate}} {{formattedCreatedTime}}</p>
        <p class="subtitle faded-color"><span *ngIf="type==='WfTask'">{{templateName ? templateName : ''}} </span>#{{referenceNumber}}</p>
      </div>

      <div style="display: flex; flex-direction: row; gap: 12px">
        <button mat-mini-fab [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <button mat-mini-fab *ngIf="!isSmallScreen" (click)="openInFullscreen()" [matTooltip]="'FULLSCREEN' | translate"><mat-icon>open_in_full</mat-icon></button>
        <button mat-mini-fab (click)="closeDetails()"><mat-icon>close</mat-icon></button>
      </div>
    </div>

    <div class="subtitle deadline-text"
        [matTooltip]="deadlineTooltip"
        matTooltipPosition="above"
         [ngClass]="{
           'warning-color': isDeadlineOverdue(deadline) && !isDraftStatus(),
           'accent-color': !isDeadlineOverdue(deadline) && isActiveStatus(),
           'draft-color': isDraftStatus(),
           'closed-color': (!isActiveStatus() && !isDraftStatus())}">
      <mat-icon *ngIf="isActiveStatus()" fontSet="material-symbols-outlined">alarm</mat-icon>
      <mat-icon *ngIf="isDraftStatus()" fontSet="material-symbols-outlined">error</mat-icon>
      <mat-icon *ngIf="!isActiveStatus() && !isDraftStatus()">check_circle</mat-icon>
      <span>{{isActiveStatus() ? formattedDeadline : (isDraftStatus() ? draftText : closedText)}}</span>
    </div>

    <div style="width: 100%; margin-top: 8px;">
      <div *ngIf="type==='WfTask'"
           style="padding-bottom: 1rem; display: flex; flex-direction:row; align-items: center">
        <span class="subtitle accent-color">{{taskName}}</span>
        <mat-icon *ngIf="taskDescription&&taskDescription.length>0"
                  [matMenuTriggerFor]="tooltipMenu" style="margin: 0 6px">info</mat-icon>
      </div>

      <!-- <div [ngClass]="{'result-div-big': !isSmallScreen, 'result-div-small': isSmallScreen}" *ngIf="isActiveStatus()&&type==='WfTask'">
        <div style="flex:2; flex-grow: 1">
          <mat-form-field style="width: 100%" subscriptSizing="dynamic">
            <mat-label><span *ngIf="isMandatoryComment()">*</span>{{'COMMENT_ON_THE_RESULT' | translate}}</mat-label>
            <textarea matInput #resultInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="3"
                      cdkAutosizeMaxRows="4"
                      [escapeAwareMaxLength]="1000"
                      [(ngModel)]="sendComment" [required]="isMandatoryComment()">
            </textarea>
            <mat-hint align="end">{{resultInput.value | escapeAwareCharCount}}/1000</mat-hint>
            <mat-error *ngIf="resultInput.checkValidity">
              {{'MANDATORY_COMMENT' | translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <div style="flex:1; display: flex; flex-direction: column">
          <mat-form-field subscriptSizing="dynamic" style="margin-bottom: 8px">
            <mat-label>{{'RESULT' | translate}}</mat-label>
            <mat-select placeholder="{{'NOT_SELECTED' | translate}}"
                        disableOptionCentering="true"
                        [(ngModel)]="selectedResult"
                        (selectionChange)="setCommentState()">
              <mat-option *ngFor="let option of possibleResults" [value]="option">{{option.displayName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-flat-button style="align-self: start"
                  [disabled]="!isResult()||(isMandatoryComment()&&!sendComment)"
                  (click)="completeTask()">
            <mat-icon>send</mat-icon>
            {{'SEND' | translate}}
          </button>
        </div>
      </div> -->
      <div [ngClass]="{'result-div-big': !isSmallScreen, 'result-div-small': isSmallScreen}" *ngIf="isActiveStatus()">
        <mat-form-field subscriptSizing="dynamic" style="margin-bottom: 8px; width: 250px">
          <mat-label>{{'RESULT' | translate}}</mat-label>
          <mat-select placeholder="{{'NOT_SELECTED' | translate}}"
                      disableOptionCentering="true"
                      [(ngModel)]="selectedResult"
                      (selectionChange)="setCommentState()">
            <mat-option *ngFor="let option of possibleResults" [value]="option">{{option.displayName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-flat-button style="align-self: start; margin-top:4px"
                [disabled]="!isResult()"
                (click)="completeTask()">
          <mat-icon>send</mat-icon>
          {{'SEND' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div>
  <mat-tab-group [selectedIndex]="tabIndex">
    <mat-tab label="{{'INFORMATION' | translate}}">
      <div style="padding: 2rem; overflow-x: hidden">
        <mat-label class="data-field-label">{{'DESCRIPTION' | translate}}</mat-label>
        <div class="desc-html" [innerHTML]="trustHtml(getDescription(), sanitizer)"></div>
        <div *ngIf="type==='WfTask'" class="metadata-fields-wrapper">
          <ng-container *ngFor="let item of metaItem">
            <ng-container *ngIf="item.visibility==='MT_M'||item.visibility==='MT_K'||item.visibility==='MT_O'">
              <ng-container [ngSwitch]="item.type">
                <app-meta-data-check *ngSwitchCase="'Check'"
                                     [label]="item.name"
                                     [visibility]="item.visibility"
                                     [(humanvalue)]="item.humanvalue"
                                     [(value)]="item.value"></app-meta-data-check>

                <app-meta-data-date *ngSwitchCase="'Date'"
                                    [label]="item.name"
                                    [visibility]="item.visibility"
                                    [(humanvalue)]="item.humanvalue"
                                    [(value)]="item.value"></app-meta-data-date>

                <app-meta-data-partner *ngSwitchCase="'Partner'"
                                       [label]="item.name"
                                       [visibility]="item.visibility"
                                       [(humanvalue)]="item.humanvalue"
                                       [(value)]="item.value"></app-meta-data-partner>

                <app-meta-data-alszam *ngSwitchCase="'Alszam'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-alszam>

                <app-meta-data-foszam *ngSwitchCase="'Foszam'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-foszam>

                <app-meta-data-mftorzs *ngSwitchCase="'MFTorzs'"
                                       [label]="item.name"
                                       [visibility]="item.visibility"
                                       [mfTorzsOptionList]="mfTorzsOptionList ? mfTorzsOptionList : []"
                                       [(humanvalue)]="item.humanvalue"
                                       [(value)]="item.value" [params]="item.params"></app-meta-data-mftorzs>

                <app-meta-data-mftorzs-ac *ngSwitchCase="'MFTorzsAC'"
                                          [label]="item.name"
                                          [visibility]="item.visibility"
                                          [mfTorzsOptionList]="mfTorzsOptionList ? mfTorzsOptionList : []"
                                          [(humanvalue)]="item.humanvalue"
                                          [(value)]="item.value" [params]="item.params"></app-meta-data-mftorzs-ac>

                <app-meta-data-money *ngSwitchCase="'Money'"
                                     [label]="item.name"
                                     [visibility]="item.visibility"
                                     [(humanvalue)]="item.humanvalue"
                                     [(value)]="item.value"></app-meta-data-money>

                <app-meta-data-number *ngSwitchCase="'Number'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value"></app-meta-data-number>

                <app-meta-data-text *ngSwitchCase="'Text'"
                                    [label]="item.name"
                                    [visibility]="item.visibility"
                                    [(humanvalue)]="item.humanvalue"
                                    [(value)]="item.value"></app-meta-data-text>

                <app-meta-data-link *ngSwitchCase="'Link'"
                                    [label]="item.name"
                                    [visibility]="item.visibility"
                                    [(humanvalue)]="item.humanvalue"
                                    [(value)]="item.value"></app-meta-data-link>

                <app-meta-data-option *ngSwitchCase="'Option'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value" [default]="item.params"></app-meta-data-option>

                <app-meta-data-textarea *ngSwitchCase="'Textarea'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value"></app-meta-data-textarea>

                <app-meta-data-workflow *ngSwitchCase="'Workflow'"
                                        [label]="item.name"
                                        [visibility]="item.visibility"
                                        [(humanvalue)]="item.humanvalue"
                                        [(value)]="item.value"></app-meta-data-workflow>

                <app-meta-data-szotar *ngSwitchCase="'Szotar'"
                                      [label]="item.name"
                                      [visibility]="item.visibility"
                                      [szotarOptionList]="dictionaryOptionList ? dictionaryOptionList : []"
                                      [(humanvalue)]="item.humanvalue"
                                      [(value)]="item.value" [params]="item.params"></app-meta-data-szotar>

                <app-meta-data-szotar-ac *ngSwitchCase="'SzotarAC'"
                                         [label]="item.name"
                                         [visibility]="item.visibility"
                                         [szotarOptionList]="dictionaryOptionList ? dictionaryOptionList : []"
                                         [(humanvalue)]="item.humanvalue"
                                         [(value)]="item.value" [params]="item.params"></app-meta-data-szotar-ac>

                <app-meta-data-szervuser *ngSwitchCase="'SzervUser'"
                                         [label]="item.name"
                                         [visibility]="item.visibility"
                                         [(humanvalue)]="item.humanvalue"
                                         [(value)]="item.value"></app-meta-data-szervuser>

                <app-meta-data-szervuser-ac *ngSwitchCase="'SzervUserAC'"
                                            [label]="item.name"
                                            [visibility]="item.visibility"
                                            [(humanvalue)]="item.humanvalue"
                                            [(value)]="item.value"></app-meta-data-szervuser-ac>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div *ngIf="type==='Task'" class="metadata-fields-wrapper">
          <ng-container *ngFor="let item of getTaskDetails()">
            <div class="additional-data-section-item">
              <mat-label class="additional-data-field-label">{{item.label}}</mat-label>
              <div class="additional-data-desc-div">
                <p *ngIf="item.value&&item.value.length>0">{{item.value}}</p>
                <p *ngIf="!item.value||item.value.length===0">-</p>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="type==='Task'">
          <table mat-table *ngIf="taskAdditionalExecutors&&taskAdditionalExecutors.length>0"
                 [dataSource]="taskAdditionalExecutors">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{'ADDITIONAL_USERS' | translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.user.fullName}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{'STATUS' | translate}}</th>
              <td mat-cell *matCellDef="let element"> {{statusFormatting(element.status)}} </td>
            </ng-container>
            <ng-container matColumnDef="result">
              <th mat-header-cell *matHeaderCellDef>{{'RESULT' | translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.result}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="taskDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: taskDisplayedColumns;"></tr>
          </table>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'ATTACHMENTS' | translate}}">
      <div style="padding: 2rem">
        <app-attachment-box-embedded [attachments]="attachments"
                                     [type]="type"
                                     [id]="id"
                                     (attachmentUploadEvent)="refreshData()"
                                     (attachmentSignEvent)="refreshData()">
        </app-attachment-box-embedded>
      </div>
    </mat-tab>
    <mat-tab label="{{'COMMENTS' | translate}}">
      <div style="padding: 2rem">
        <app-message-box-embedded [comments]="comments"
                                  [type]="type"
                                  [id]="id" (messageUploadEvent)="refreshData()">
        </app-message-box-embedded>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item (click)="onForwardTask()" [disabled]="!isActiveStatus()">
    <mat-icon>forward</mat-icon>
    <span>{{'FORWARD' | translate}}</span>
  </button>
  <button mat-menu-item *ngIf="type==='WfTask'" (click)="callDetailsEvent()">
    <mat-icon>info</mat-icon>
    <span>{{'WORKFLOW_INFO' | translate}}</span>
  </button>
  <button mat-menu-item *ngIf="type==='WfTask'" (click)="openDigraphDiagram()">
    <mat-icon>account_tree</mat-icon>
    <span>{{'WORKFLOW_TEMPLATE_DIAGRAM' | translate}}</span>
  </button>
<!--  <button mat-menu-item *ngIf="isSmallScreen&&!isDetailsPage" [routerLink]="routeToInfo()">{{'DETAILS' | translate}}</button>-->
<!--  <button mat-menu-item *ngIf="isSmallScreen&&isDetailsPage" (click)="callDetailsEvent()">{{'DETAILS' | translate}}</button>-->
</mat-menu>
<mat-menu #tooltipMenu="matMenu" [overlapTrigger]="false">
  <div style="margin: 1rem" [innerHTML]="trustHtml(taskDescription, sanitizer)"></div>
</mat-menu>
